module.exports = __webpack_public_path__ + "static/media/comp1.a57236fc.png";